import adminHttp from "/src/api/adminHttp";

const END_POINT = '/api/admin/platforms';

export default {
    /**
     * GET: Organizers
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    index: () => adminHttp.get(END_POINT),
}